import { RootState } from "../RootReducer";
import { IFilter } from "./Filter";

export const Filters = (state: RootState): IFilter[] => state.filters.filterList;
export const FiltersLoading = (state: RootState): boolean => state.filters.loading;
export const SelectedFilters = (state: RootState): IFilter[] => state.filters.selectedFilters;
export const SelectedFilterTitle = (state: RootState): string | undefined => state.filters.selectedFilterTitle;